export const GoSearch = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.0235 18.0416C14.8992 18.0416 18.0411 14.8997 18.0411 11.024C18.0411 7.14824 14.8992 4.00635 11.0235 4.00635C7.14775 4.00635 4.00586 7.14824 4.00586 11.024C4.00586 14.8997 7.14775 18.0416 11.0235 18.0416Z"
      stroke="#64748B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.0352 16.0366L22.0502 22.0517" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
